module.exports = __webpack_public_path__ + "img/page1-6.8902b9c0.png";